import { inject, Injectable, signal, WritableSignal } from "@angular/core";
import { Subject } from "rxjs";
import { ConnectedPosition } from "@angular/cdk/overlay";
import { keysLS, LocalStorageService } from "@app/core/services";

export interface ItemMenu {
  header: string;
  visible: boolean | string | string[];
  icon: string[];
  url: string[];
  expanded: boolean;
  children?: SubItemMenu[];
}

export type SubItemMenu = Omit<ItemMenu, "expanded" | "icon" | "children">;

@Injectable({
  providedIn: "root",
})
export class NavBarService {
  public readonly positions: ConnectedPosition[] = [
    {
      originX: "end",
      originY: "top",
      overlayX: "start",
      overlayY: "top",
      offsetX: 6,
    },
  ];
  private readonly localStorageService = inject(LocalStorageService);
  private readonly isMinimized = signal<boolean>(false);
  private readonly menuItems = signal<ItemMenu[]>([
    {
      header: "layouts.navigation.HOME",
      visible: true,
      icon: ["Base", "home"],
      url: ["/", "home"],
      expanded: false,
    },
    {
      header: "layouts.navigation.EMPLOYEES",
      visible: "TAB_EMPLOYEES_DISPLAY",
      icon: ["Peoples", "peoples"],
      url: ["/", "employees", "users"],
      expanded: false,
    },
    {
      header: "layouts.navigation.STATUS_MCH",
      visible: "TAB_STATUS-MERCH_DISPLAY",
      icon: ["Edit", "calendar"],
      url: ["/", "status-mch"],
      expanded: false,
    },
    {
      header: "layouts.navigation.POSM",
      visible: "TAB_POSM_DISPLAY",
      icon: ["Edit", "calendar-success"],
      url: ["/", "posm"],
      expanded: false,
      children: [
        {
          header: "layouts.navigation.LIBERY",
          visible: "TAB_POSM_LIBRARY_DISPLAY",
          url: ["/", "posm", "library"],
        },
        {
          header: "layouts.navigation.LOADPOSM",
          visible: "BUTTON_POSM_CREATE_DISPLAY",
          url: ["/", "posm", "load"],
        },
        {
          header: "layouts.navigation.LOADORDER",
          visible: "TAB_ORDER_CREATE_DISPLAY",
          url: ["/", "posm", "load-order"],
        },
        {
          header: "layouts.navigation.ORDERS",
          visible: "TAB_ORDER_DISPLAY",
          url: ["/", "posm", "orders"],
        },
        {
          header: "layouts.navigation.LOADADRESS",
          visible: "TAB_POSM_GETFILES_DISPLAY",
          url: ["/", "posm", "load-adress"],
        },
        {
          header: "layouts.navigation.DELIVERIES",
          visible: "TAB_DELIVERY_DISPLAY",
          url: ["/", "posm", "deliveries"],
        },
        {
          header: "layouts.navigation.REESTR_ANKET",
          visible: "TAB_POSM_REESTR_DISPLAY",
          url: ["/", "posm", "reestr-anket"],
        },
      ],
    },
    {
      header: "layouts.navigation.LOGISTIC",
      visible: "TAB_LOGISTIC_DISPLAY",
      icon: ["Edit", "marker-alt"],
      url: ["/", "logistic", "merchandisers"],
      expanded: false,
    },
    {
      header: "layouts.navigation.ROUTES",
      visible: "TAB_ROUTES_DISPLAY",
      icon: ["Edit", "routes"],
      url: ["/", "routes"],
      expanded: false,
      children: [
        {
          header: "layouts.navigation.ROUTES_ROUTE-PLAN",
          visible: "TAB_ROUTES_ROUTE-PLAN_DISPLAY",
          url: ["/", "routes", "route-plans"],
        },
        {
          header: "layouts.navigation.ROUTES_LOAD-FILES",
          visible: "TAB_ROUTES_LOAD-FILES_DISPLAY",
          url: ["/", "routes", "load-files"],
        },
      ],
    },
    {
      header: "layouts.navigation.MATRIX",
      visible: "TAB_CL_STORES_DISPLAY",
      icon: ["Edit", "matrix"],
      url: ["/", "matrix"],
      expanded: false,
      children: [
        {
          header: "layouts.navigation.MATRIX_STORES",
          visible: "TAB_CL_STORES_DISPLAY",
          url: ["/", "matrix", "stores"],
        },
        {
          header: "layouts.navigation.MATRIX_LOADER",
          visible: "TAB_CL_GETFILES_DISPLAY",
          url: ["/", "matrix", "loader"],
        },
        {
          header: "layouts.navigation.MATRIX_CONTRACT_LIST",
          visible: "TAB_CL_FORMATS_DISPLAY",
          url: ["/", "matrix", "contract-list"],
        },
        {
          header: "layouts.navigation.MATRIX_FORMATS",
          visible: "TAB_CL_FORMATS_DISPLAY",
          url: ["/", "matrix", "formats"],
        },
      ],
    },
    {
      header: "layouts.navigation.BI_REPORTS",
      visible: false,
      icon: ["Charts", "chart-proportion"],
      url: ["/", "bi-reports"],
      expanded: false,
    },
    {
      header: "layouts.navigation.STORES",
      visible: "TAB_STORES_DISPLAY",
      icon: ["Build", "application"],
      url: ["/", "stores"],
      expanded: false,
    },
    {
      header: "layouts.navigation.REPORTS",
      visible: "TAB_REPORTS_DISPLAY",
      icon: ["Charts", "chart-pie"],
      url: ["/", "reports"],
      expanded: false,
      children: [
        {
          header: "layouts.navigation.REPORTS_PHOTO",
          visible: "TAB_REPORTS_PHOTO_DISPLAY",
          url: ["/", "reports", "photo"],
        },
        {
          header: "layouts.navigation.REPORTS_SERVICE",
          visible: "TAB_REPORTS_SERVICE_DISPLAY",
          url: ["/", "reports", "service"],
        },
        {
          header: "layouts.navigation.REPORTS_EXCEL",
          visible: "TAB_REPORTS_EXCEL_DISPLAY",
          url: ["/", "reports", "excel"],
        },
        {
          header: "layouts.navigation.ORDER",
          visible: "TAB_REPORTS_EXCEL_DISPLAY",
          url: ["/", "reports", "order"],
        },
      ],
    },
    // Раздел Краудсорсинг законсервирован по задаче TASK-1526 (https://ziminatrsuper.atlassian.net/browse/SCRUM-1526)
    // {
    //   header: "layouts.navigation.CROWDSOUNCING",
    //   visible: "TAB_CROWDSOUNCING_DISPLAY",
    //   icon: ["Character", "info"],
    //   url: ["/", "crowdsourcing"],
    //   expanded: false,
    //   children: [
    //     {
    //       header: "layouts.navigation.LOTS",
    //       visible: "TAB_REPORTS_CROWDSOUNCING_LOTS_DISPLAY",
    //       url: ["/", "crowdsourcing", "lots"],
    //     },
    //     {
    //       header: "layouts.navigation.EMPLOYEERS",
    //       visible: "TAB_CROWDSOUNCING_EMPLOYEERS_DISPLAY",
    //       url: ["/", "crowdsourcing", "employeers"],
    //     },
    //     {
    //       header: "layouts.navigation.DOCUMENTS",
    //       visible: "TAB_CROWDSOUNCING_EMPLOYEERS_DISPLAY",
    //       url: ["/", "crowdsourcing", "documents"],
    //     },
    //     {
    //       header: "layouts.navigation.PAYMENTS",
    //       visible: "TAB_CROWDSOUNCING_PAYMENTS_DISPLAY",
    //       url: ["/", "crowdsourcing", "payments"],
    //     },
    //     {
    //       header: "layouts.navigation.PAYMENTS_CREATE",
    //       visible: "TAB_CROWDSOUNCING_PAYMENTS_CREATE_DISPLAY",
    //       url: ["/", "crowdsourcing", "payment-create"],
    //     },
    //   ],
    // },
    {
      header: "layouts.navigation.CONSTRUCTOR_PLANOGRAMM",
      visible: false,
      icon: ["Hardware", "hand-painted-plate"],
      url: ["/", "constructor"],
      expanded: false,
    },
    {
      header: "layouts.navigation.VISITS",
      visible: "TAB_VISITS_DISPLAY",
      icon: ["Components", "checklist"],
      url: ["/", "visits"],
      expanded: false,
    },
    {
      header: "layouts.navigation.MASS_VISITS",
      visible: "TAB_MASSIVE_CHANGES_DISPLAY",
      icon: ["Arrows", "upload"],
      url: ["/", "mass-visits"],
      expanded: false,
    },
    {
      header: "layouts.navigation.ADMINISTRATIONS",
      visible: "TAB_ADMINISTRATIONS_DISPLAY",
      icon: ["Peoples", "user-business"],
      url: ["/", "administration"],
      expanded: false,
      children: [
        {
          header: "layouts.navigation.GET_FILES",
          visible: true,
          url: ["/", "administration", "get-files"],
        },
        {
          header: "layouts.navigation.PROJECTS",
          visible: true,
          url: ["/", "administration", "projects"],
        },
        {
          header: "layouts.navigation.APPLICATIONS",
          visible: true,
          url: ["/", "administration", "applications"],
        },
        {
          header: "layouts.navigation.STATUS",
          visible: true,
          url: ["/", "administration", "status"],
        },
        {
          header: "layouts.navigation.SMS",
          visible: true,
          url: ["/", "administration", "sms"],
        },
        {
          header: "layouts.navigation.JIRA_TASK_TIME_REPORT",
          visible: true,
          url: ["/", "administration", "jira-task-time-report"],
        },
        {
          header: "layouts.navigation.MATERIALS",
          visible: true,
          url: ["/", "administration", "materials"],
        },
      ],
    },
    {
      header: "layouts.navigation.CAP",
      visible: "TAB_CAP_DISPLAY",
      icon: ["Arrows", "upload-one"],
      url: ["/", "cap", "main"],
      expanded: false,
    },
    {
      header: "layouts.navigation.PROMO",
      visible: ["TAB_OREH-PROMO_DISPLAY", "TAB_DONON-PROMO_DISPLAY"],
      icon: ["Money", "insert-card"],
      url: ["/", "other", "promo"],
      expanded: false,
    },
    {
      header: "layouts.navigation.EQUIPMENT",
      visible: "TAB_EQUIPMENT_REQUESTS_DISPLAY",
      icon: ["Industry", "spanner"],
      url: ["/", "other"],
      expanded: false,
      children: [
        {
          header: "layouts.navigation.EQUIPMENT_REQUESTS",
          visible: "TAB_EQUIPMENT_REQUESTS_LIST_DISPLAY",
          url: ["/", "requests", "main"],
        },
        {
          header: "layouts.navigation.EQUIPMENT_REQUESTS_UPLOAD",
          visible: "TAB_EQUIPMENT_REQUESTS_UPLOAD_DISPLAY",
          url: ["/", "requests", "upload"],
        },
        {
          header: "layouts.navigation.REQUEST",
          visible: "TAB_EQUIPMENT_REQUESTS_REQUEST_DISPLAY",
          url: ["/", "other", "request"],
        },
        {
          header: "layouts.navigation.EQUIPMENTS",
          visible: "TAB_EQUIPMENT_REQUESTS_EQUIPMENTS_DISPLAY",
          url: ["/", "equipments", "main"],
        },
        {
          header: "layouts.navigation.EQUIPMENTS_DIRECTORY-AP",
          visible: "TAB_EQUIPMENT_REQUESTS_ADDRESS_PROGRAMM_DISPLAY",
          url: ["/", "equipments", "directory-ap"],
        },
      ],
    },
    {
      header: "layouts.navigation.FILEHOSTING",
      visible: "TAB_FILEHOSTING_DISPLAY",
      icon: ["Office", "folder-open"],
      url: ["/", "filehosting"],
      expanded: false,
    },
  ]);
  private closeAllPopupsSource = new Subject<void>();
  public closeAllPopups$ = this.closeAllPopupsSource.asObservable();

  public constructor() {
    const hasMinimizedLS = this.localStorageService.has(
      keysLS.isMinimisedNavBar
    );

    if (hasMinimizedLS) {
      const isMinimizedLS = this.localStorageService.get<boolean>(
        keysLS.isMinimisedNavBar
      ) as boolean;
      this.isMinimized.set(isMinimizedLS);
    }
  }

  public toggleExpandedItemByHeader(header: string): void {
    this.menuItems.update((items) =>
      items.map((item: ItemMenu) =>
        item.header === header ? { ...item, expanded: !item.expanded } : item
      )
    );
  }

  public toggleIsMinimized(): void {
    this.isMinimized.update((isMinimized) => !isMinimized);
    this.localStorageService.set(keysLS.isMinimisedNavBar, this.isMinimized());

    if (this.isMinimized()) {
      this.unExpandAllItems();
    }
  }

  public closeAllPopups(): void {
    this.closeAllPopupsSource.next();
  }

  public getSignalIsMinimized(): WritableSignal<boolean> {
    return this.isMinimized;
  }

  public getSignalMenuItems(): WritableSignal<ItemMenu[]> {
    return this.menuItems;
  }

  public unExpandAllItems(): void {
    this.menuItems.update((items) =>
      items.map((item: ItemMenu) => ({ ...item, expanded: false }))
    );
  }
}
